export const myPosTheme = {
  globals: {
    name: 'myPos',
    fontFamily: 'Inter',
    fontFamilyHeadline: 'Inter',
    fontFamilyBold: 'Inter',
    bgColor: '#FFFFFF',
    linkColor: 'rgba(0, 113, 243, 1)',
    linkColorHover: 'rgba(66, 152, 251, 1)',
    checkboxColor: 'rgba(52, 53, 58, 1)',
    checkboxColorActive: 'rgba(0, 113, 243, 1)',
    checkboxBorderRadius: '4px',
    inputRequired: {
      asteriskColor: 'rgba(0, 113, 243, 1)',
      textColor: 'rgba(0, 113, 243, 1)',
      textFontSize: '14px',
    },
  },
  contentWrap: {},
  container: {
    bgColor: '#FFFFFF',
    width: '100%',
    padding: '50px',
    borderRadius: '8px',
    border: '1px solid rgba(230, 221, 249, 1)',
    boxShadow: '2px 2px 10px 0px rgba(0, 0, 0, 0.07)',
    margin: '0 auto',
    color: 'rgba(52, 53, 58, 1)',
  },
  documentCheckbox: {
    iconColor: 'rgba(52, 53, 58, 1)',
    iconHover: 'rgba(0, 0, 0, 1)',
    width: '100%',
    contentFontSize: '14px',
    margin: '20px',
  },
  icon: {
    docVerifyDotsColor: 'rgba(255, 255, 255, 1)',
    mainIconColor: 'rgba(0, 113, 243, 1)',
    colorHover: 'rgba(0, 113, 243, 1) ',
    backgroundColor: 'rgba(247, 249, 252, 1)',
    size: '32px',
    thickness: '0.2px',
  },
  otpInput: {
    width: '100%',
    columnGap: '10px',
    marginTop: '10px',
    marginBottom: '30px',
    inputHeight: '60px',
    inputBorder: '2px solid rgba(206, 212, 220, 1)',
    borderRadius: '2px',
    fontSize: '22px ',
    focusColor: 'rgba(0, 113, 243, 1)',
    bgColor: 'rgba(255, 255, 255, 1)',
    focusBgColor: 'rgba(255, 255, 255, 1)',
    fontColor: 'rgba(0, 0, 0, 1)',
    loadingColor: 'rgba(0, 113, 243, 1)',
  },
  pdfViewer: {
    pageBackground: '#FFFFFF',
    containerBorder: '2px solid rgba(206, 212, 220, 1)',
    scrollTrackColor: '#CED4DC',
    scrollHandleColor: 'rgba(0, 113, 243, 1)',
    scrollRadius: '0px',
    toolbox: {
      color: '#FFFFFF',
      bgColor: 'rgba(0, 0, 0, 0.70)',
      borderRadius: '4px',
      padding: '5px',
      boxShadow: '#none',
    },
    zoomButton: {
      bgColor: '#FFFFFF',
      color: '#34353A',
      border: '1px solid #CECBD6',
      bgColorHover: '#F1F3F7',
      colorHover: '#34353A',
      borderHover: '1px solid #CECBD6',
    },
    pageRangeInput: {
      trackColor: '#CECBD6',
      activeTrackColor: '#34353A',
      thumbColor: '#34353A',
      thumbHoverColor: '#34353ACC',
      thumbFocusBorderColor: '',
    },
  },
  downloadDocumentButton: {
    bgColor: '#FFFFFF',
    color: '#34353A',
    borderColor: '#CECBD6',
    bgColorHover: '#F1F3F7',
    colorHover: '#34353A',
    borderColorHover: '#CECBD6',
    bgColorDisabled: '#F6F6F6',
    colorDisabled: '#91969B',
    borderColorDisabled: '#F6F6F6',
  },
  button: {
    bgColor: 'rgba(0, 113, 243, 1)',
    padding: '10px 34px',
    borderRadius: '100px',
    width: 'auto',
    border: '1px solid rgba(0, 113, 243, 1)',
    boxShadow: 'none',
    margin: '0',
    color: 'rgba(255, 255, 255, 1)',
    colorHover: 'rgba(255, 255, 255, 1)',
    bgColorHover: 'rgba(66, 152, 251, 1)',
    borderHover: '1px solid rgba(66, 152, 251, 1)',
    bgColorDisabled: 'rgba(206, 212, 220, 1)',
    borderDisabled: '1px solid rgba(206, 212, 220, 1)',
    colorDisabled: 'rgba(52, 53, 58, 1)',
    fontSize: '14px',
    fontWeight: '500',
  },
  buttonSecondary: {
    bgColor: 'transparent',
    padding: '10px 34px',
    borderRadius: '100px',
    width: 'auto',
    border: '1px solid #DCDBE2',
    boxShadow: 'none',
    margin: '0',
    color: '#34353A',
    colorHover: 'rgba(255, 255, 255, 1)',
    bgColorHover: 'rgba(66, 152, 251, 1)',
    borderHover: '1px solid rgba(66, 152, 251, 1)',
    bgColorDisabled: 'rgba(206, 212, 220, 1)',
    borderDisabled: '1px solid rgba(206, 212, 220, 1)',
    colorDisabled: 'rgba(52, 53, 58, 1)',
    fontSize: '14px',
    fontWeight: '500',
  },
  buttonDisabled: {
    padding: '10px 34px',
    borderRadius: '100px',
    width: 'auto',
    boxShadow: 'none',
    margin: '0',
    fontSize: '14px',
    fontWeight: '500',
    bgColor: 'rgba(206, 212, 220, 1)',
    border: '1px solid rgba(206, 212, 220, 1)',
    color: 'rgba(52, 53, 58, 1)',
    bgColorHover: 'rgba(206, 212, 220, 1)',
    borderHover: '1px solid rgba(206, 212, 220, 1)',
    colorHover: 'rgba(52, 53, 58, 1)',
    cursor: 'not-allowed',
  },
  header: {
    color: 'rgba(52, 53, 58, 1)',
    fontSize: '1.5rem',
    lineHeight: '2.25rem',
    fontSizeMobile: '1.25rem',
    lineHeightMobile: '1.9375rem',
    margin: '15px 0',
    textAlign: 'center',
    width: '100%',
  },
  selectInput: {
    borderRadius: '2px',
    borderWidth: '1px',
    borderColorFocus: 'rgba(206, 212, 220, 1)',
    backgroundColorSelected: 'rgba(206, 212, 220, 1)',
    backgroundColorFocus: 'rgba(206, 212, 220, 0.75)',
    currentBg: 'rgba(206, 212, 220, 0.50)',
    indicatorColorFocus: 'rgb(102, 102, 102)',
    indicatorColorHover: 'rgb(153, 153, 153)',
    danger: 'rgba(226,64,40,1)',
    dangerLight: 'rgba(226,64,40,0.5)',
  },
  symbol: {
    primary: 'rgba(0, 113, 243, 1)',
    secondary: 'rgba(255, 255, 255, 1)',
    tenary: 'rgba(248, 247, 246, 1)',
  },
  textInput: {
    bgColor: 'white',
    padding: '14px',
    borderRadius: '2px',
    border: '2px solid rgba(206, 212, 220, 1)',
    boxShadow: 'none',
    margin: '0',
    color: 'rgba(0, 0, 0, 1)',
    colorFocus: 'rgba(0, 0, 0, 1)',
    bgColorFocus: 'white',
    borderFocus: '2px solid rgba(0, 0, 0, 1)',
    bgColorDisabled: 'rgba(206, 212, 220, 1)',
    borderDisabled: 'rgba(206, 212, 220, 1)',
    colorDisabled: 'rgba(206, 212, 220, 1)',
    fontSize: '14px',
    fontWeight: '300',
    outline: 'none',
    errorColor: '#d91111',
  },
  brandBar: {
    bgColor: 'white ',
    padding: '30px',
    margin: '0 0 30px 0',
    border: 'none',
    boxShadow: 'none',
    justifyContent: 'normal',
  },
  wrapXs2a: {
    fontFamily: 'Inter',
    fontFamilyHeadline: 'Inter',
    bgColor: 'rgba(248, 247, 246, 1)',
    linkColor: 'rgba(0, 113, 243, 1)',
    linkColorHover: 'rgba(66, 152, 251, 1)',
    checkboxColor: 'rgba(52, 53, 58, 1)',
    checkboxColorActive: 'rgba(0, 113, 243, 1)',
    backButton: {
      borderColor: 'rgba(0, 113, 243, 1)',
      color: 'rgba(52, 53, 58, 1)',
      colorHover: 'rgba(0, 0, 0, 1)',
      disabled: 'rgba(206, 212, 220, 1)',
    },
    input: {
      bgColor: 'white',
      padding: '14px',
      borderRadius: '2px',
      border: '2px solid rgba(206, 212, 220, 1)',
      boxShadow: 'none',
      margin: '0',
      color: 'rgba(0, 0, 0, 1)',
      colorFocus: 'rgba(0, 0, 0, 1)',
      bgColorFocus: 'white',
      borderFocus: '2px solid rgba(0, 0, 0, 1)',
      bgColorDisabled: 'rgba(206, 212, 220, 1)',
      borderDisabled: 'rgba(206, 212, 220, 1)',
      colorDisabled: 'rgba(206, 212, 220, 1)',
      fontSize: '14px',
      fontWeight: '300',
      outline: 'none',
      errorColor: '#d91111',
    },
    button: {
      bgColor: 'rgba(0, 113, 243, 1)',
      padding: '10px 34px',
      paddingMobile: '14px 40px',
      borderRadius: '2px',
      width: 'auto',
      border: '1px solid rgba(0, 113, 243, 1)',
      boxShadow: 'none',
      margin: '0',
      color: 'rgba(255, 255, 255, 1)',
      colorHover: 'rgba(255, 255, 255, 1)',
      bgColorHover: 'rgba(66, 152, 251, 1)',
      borderHover: '1px solid rgba(66, 152, 251, 1)',
      bgColorDisabled: 'rgba(206, 212, 220, 1)',
      borderDisabled: '1px solid rgba(206, 212, 220, 1)',
      colorDisabled: 'rgba(52, 53, 58, 1)',
      fontSize: '16px',
      fontWeight: '700',
    },
  },
  wrapKlarna: {
    bgColor: 'rgba(206, 212, 220, 1)',
  },
  wrapKontomatik: {
    bgColor: '#FFF',
    textColor: 'rgba(52, 53, 58, 1)',
    borderColor: 'rgba(228, 228, 228, 1)',
    headerColor: 'rgba(52, 53, 58, 1)',
    primaryColor: 'rgba(0, 113, 243, 1)',
    primaryReverseColor: '#FFF',
    secondaryColor: '586374',
    mainHoverColor: 'rgba(66, 152, 251, 1)',
    mainHoverReverseColor: '#FFF',
    listHoverColor: '#F5F5F5',
    disabledColor: '#CED4DA',
    errorColor: '#BB0000',
    borderRadius: '2px',
    width: '100%',
    padding: '50px',
    boxShadow: 'none',
    margin: '0 auto',
  },
  progressBar: {
    time: 180,
    secondChance: true,
    showCounter: true,
    height: '17px',
    margin: '40px 0 10px 0',
    padding: '0 20px',
    border: '2px solid rgba(206, 212, 220, 1)',
    borderRadius: '0px',
    background: 'white',
    barFill: 'rgba(0, 113, 243, 1)',
    counterMargin: '20px 0',
    counterPadding: '0',
    counterFontSize: '24px',
    counterColor: 'rgba(52, 53, 58, 1)',
    infoMessageTextAlign: 'center',
    infoMessageFontSize: '12px',
    infoMessageMargin: '6px 0 0 0',
  },
  stepper: {
    borderColor: 'rgba(206, 212, 220, 1)',
    fontSizeTitle: '12px',
    fontSizeDesc: '10px',
  },
  loadingSpinner: {
    primary: 'rgba(0, 113, 243, 1)',
    bgColor: 'rgba(255, 255, 255, 1)',
  },
  tabSwitcher: {
    borderBottom: '2px solid #dbdbdb',
    buttonColor: '#9b9b9b',
    buttonBorderBottom: '4px solid rgba(0, 113, 243, 1)',
    buttonColorActive: '#000',
  },
  errorPage: {
    title: {
      color: 'rgba(52, 53, 58, 1)',
    },
    subtitle: {
      color: '#98959f',
    },
    svg: {
      fill1: 'none',
      fill2: '#ffffff',
      fill3: '#000',
      fill4: 'rgba(0, 113, 243, 1)',
    },
  },
  popup: {
    clickOutsideEnabled: true,
  },
  videoIdCallToActionButton: {
    bgColor: 'rgba(0, 113, 243, 1)',
    padding: '10px 34px',
    borderRadius: '2px',
    width: '150px',
    border: '1px solid rgba(0, 113, 243, 1)',
    boxShadow: 'none',
    margin: '32px 0 0 0',
    color: 'rgba(255, 255, 255, 1)',
    colorHover: 'rgba(255, 255, 255, 1)',
    bgColorHover: 'rgba(66, 152, 251, 1)',
    borderHover: '1px solid rgba(66, 152, 251, 1)',
    bgColorDisabled: 'rgba(206, 212, 220, 1)',
    borderDisabled: '1px solid rgba(206, 212, 220, 1)',
    colorDisabled: 'rgba(52, 53, 58, 1)',
    fontSize: '16px',
    fontWeight: '700',
    textDecoration: 'none',
  },
  videoIdPhoneChangeButton: {
    color: 'rgba(0, 113, 243, 1)',
  },
}
